import { cn } from "@/lib/classNames";

export type EngravedTab = {
  id: string;
  label: string;
};

type EngravedTabsProps = {
  tabs: readonly EngravedTab[];
  activeId: string;
  onSelect: (id: string) => void;
  className?: string;
  /** @deprecated No longer used; tabs use soft fills only. Kept for call-site compatibility. */
  subtleBorders?: boolean;
  /** Narrow, content-sized tabs aligned to the start (no full-width stretch). */
  variant?: "default" | "inline";
};

export function EngravedTabs({
  tabs,
  activeId,
  onSelect,
  className,
  variant = "default",
}: EngravedTabsProps) {
  const inline = variant === "inline";

  return (
    <div className={cn(inline ? "inline-flex max-w-full items-center gap-1" : "flex w-full items-center gap-1", className)}>
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onSelect(tab.id)}
            className={cn(
              "relative rounded-md text-sm font-semibold tracking-normal transition-colors",
              inline ? "shrink-0 px-3 py-1.5" : "min-w-0 flex-1 px-4 py-2.5",
              active
                ? "bg-neutral-950/12 text-neutral-950 hover:bg-neutral-950/18"
                : "bg-transparent text-neutral-600 hover:bg-neutral-950/8 hover:text-neutral-950",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
